import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { helper } from 'src/environments/helper';
import { CereriService } from '../cereri.service';
import { UsersService } from 'src/app/services/users.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UpdateMassAssignPayload } from '../cerere.interface';
import { DirectiiService } from 'src/app/services/directii.service';

@Component({
    selector: 'app-cereri-asigneaza',
    templateUrl: './cereri-asigneaza.component.html',
    styleUrls: ['./cereri-asigneaza.component.scss'],
})
export class CereriAsigneazaComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    // directii$!: Observable<Generic[]>;
    // compartimenteActive$!: Observable<Generic[]>;
    compartimente: Generic[] = [];
    users$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        // directie_id: new FormControl('', [Validators.required]),
        compartiment_id: new FormControl('', [Validators.required]),
        operator: new FormControl('', []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: number[],
        private dialogRef: MatDialogRef<CereriAsigneazaComponent>,
        // private directiiService: DirectiiService,
        private cereriService: CereriService,
        // private usersService: UsersService,
        private notificationService: NotificationService
    ) { }

    ngOnInit(): void {
        // this.loadRequestStatuses();
        // this.loadOperatori();
        this.loadCompartimente();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    //   onDirectieChange(directieId: number): void {
    //     if (directieId) {
    //       this.loadCompartimenteActive(directieId);
    //     } else {
    //       this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
    //         // observer.next([{ name: '--Alegeți--', id: -1 }]);
    //         observer.complete();
    //       });
    //     }
    //   }

    /*
      Commented the default parameter because the BE cannot accept negative values
    */

    loadCompartimente() {
        this.isLoading = true;
        this.cereriService
            .getCompartimenteByAutcom()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.compartimente = results;
                },
                error: (error) => {
                    console.error('Error loading compartimente', error);
                    this.isLoading = false;
                },
            });
    }

    onCompartimenteChange(compartimentId: number): void {
        if (compartimentId) {
            this.form.controls['operator'].patchValue('');
            this.loadOperatori(compartimentId);
        } else {
            this.users$ = new Observable<Generic[]>((observer) => {
                observer.complete();
            });
        }
    }

    //   loadCompartimenteActive(directieId?: number) {
    //     this.isLoading = true;
    //     let compartimenteObservable$ = directieId
    //       ? this.cereriService.getCompartimenteByDirectieId(directieId)
    //       : this.cereriService.getCompartimenteActive();

    //     this.compartimenteActive$ = compartimenteObservable$.pipe(
    //       finalize(() => {
    //         this.isLoading = false;
    //       })
    //     );
    //   }

    //   loadRequestStatuses() {
    //     this.isLoading = true;
    //     this.directii$ = this.directiiService.getDirectii().pipe(
    //       // map((results: any) => [...results, this.defaultParameter]),
    //       finalize(() => (this.isLoading = false))
    //     );
    //   }

    //   loadOperatori() {
    //     this.isLoading = true;
    //     this.users$ = this.usersService.getUsers().pipe(
    //       // map((results: any) => [...results, this.defaultParameter]),
    //       finalize(() => (this.isLoading = false))
    //     );
    //   }

    loadOperatori(compartimentId: number) {
        this.isLoading = true;
        this.users$ = this.cereriService
            .getOperatoriByCompartiment(compartimentId)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => {
                    this.isLoading = false;
                })
            );
    }

    submitForm() {
        this.isLoading = true;

        const ids_cerere = this.data;
        // const directie_id = this.form.get('directie_id')?.value;
        const compartiment_id = this.form.get('compartiment_id')?.value;
        const user_id = this.form.get('operator')?.value;

        const newAssign: UpdateMassAssignPayload = {
            ids_cerere,
            // directie_id: directie_id,
            compartiment_id: compartiment_id,
            user_id: user_id,
        };

        this.cereriService
            .updateMassAssign(newAssign)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
